import * as React from 'react';
import {TypeImplementation, withSystem, withMeta} from '@packages/systems/wfdl';
import * as wast from '@packages/systems/wfdl-ast';
import * as wq from '@packages/systems/wfdl-Qualified';
import {LogicLabel} from '@packages/systems/flows/shared';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';
import {TNonEmptyText} from '@packages/systems/plugins/Text';

const CHOOSE_EXISTING_ITEM = 'View items';
const ADD_ID_MANUALLY = 'Add item ID';

const manualIDType = withSystem(
  {bindUIVariant: 'custom'},
  withMeta({placeholder: 'Enter item ID...'}, TNonEmptyText)
);

const itemIdType = withMeta(
  {variant: 'menu'},
  withSystem(
    {isFullWidth: true, labelVariant: 'hidden', label: 'Item ID'},
    wast.TUnion({
      [ADD_ID_MANUALLY]: manualIDType,
      [CHOOSE_EXISTING_ITEM]: wast.TTypeConstructor(
        wq.qualify(wq.pluginName('CMS'), wq.typeName('Item Search'))
      ),
    })
  )
);

/**
 * The select with the options 'View items' and 'Add item ID'
 */
export const ItemIDDropdown = TypeImplementation.Alias({
  system: {isFullWidth: true, labelVariant: 'hidden'},
  type: itemIdType,
  render: function ItemIDDropdown({expr, dispatch}) {
    return (
      <>
        <LogicLabel required label="Item" />
        <ExpressionEditor dispatch={dispatch} expression={expr} />
      </>
    );
  },
});
